// productConfig.ts
import foreFlightLogo from '../../client-dashboard/client-dashboard-assets/product-suit-assets/fore-flight-logo.png';
import fiResponseLogo from '../../client-dashboard/client-dashboard-assets/product-suit-assets/firesponse-logo.png';
import fnnLogo from '../../img/FNNLogoWithWhiteFont-07.png';

// Toggle this flag for local vs production API URLs
const USE_LOCALHOST = false; // set to false for production
const BASE_URL = USE_LOCALHOST ? 'http://localhost:8000' : '';

// Helper to build API URLs
const buildApiUrl = (path: string) => `${BASE_URL}${path}`;

// Helper to build details endpoint for a given org field
const detailsEndpoint = (path: string, orgField: string) => (org: any) =>
  org[orgField] ? buildApiUrl(`${path}?org_id=${org[orgField]}`) : null;

export interface ProductConfig {
  title: string;
  logo: string;
  api: {
    orgList?: string; // endpoint for orgs
    details?: (org: any) => string | null; // function to build details endpoint per org
  };
  popup: boolean;
}

export const productConfigs: Record<string, ProductConfig> = {
  foreflight: {
    title: 'ForeFlight',
    logo: foreFlightLogo,
    api: {
      orgList: buildApiUrl('/portal/api/marketing_orgs/'),
      details: detailsEndpoint('/portal/api/org-emails/', 'ORG_FOREFLIGHT_ID'),
    },
    popup: true,
  },

  email_dispatch: {
    title: 'Email Dispatch',
    logo: fnnLogo,
    api: {
      orgList: buildApiUrl('/portal/api/marketing_orgs/'),
      details: detailsEndpoint('/portal/api/org-emails/', 'ORG_FOREFLIGHT_ID'),
    },
    popup: true,
  },

  api_endpoint: {
    title: 'API Endpoint',
    logo: fnnLogo,
    api: {
      orgList: buildApiUrl('/portal/api/marketing_orgs/'),
      details: detailsEndpoint('/portal/api/org-emails/', 'API_ENDPOINT_ID'),
    },
    popup: false,
  },

  // api_endpoint: {
  //   title: 'API Endpoint',
  //   logo: fnnLogo,
  //   api: {
  //     orgList: `${BASE_URL}/portal/api/marketing_orgs/`,
  //     details: (org) =>
  //       org.API_ENDPOINT_ID
  //         ? `${BASE_URL}/portal/api/org-emails/?org_id=${org.ORG_FOREFLIGHT_ID}`
  //         : null,
  //   },
  //   popup: false,
  // },

  // firesponse: {
  //   title: 'fiResponse',
  //   logo: fiResponseLogo,
  //   api: {
  //     orgList: buildApiUrl('/portal/api/marketing_orgs/'),
  //     details: detailsEndpoint('/portal/api/firesponse-details/', 'API_ENDPOINT_ID'),
  //   },
  // },
};
